/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { useContext, memo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Video, VideoThumbnail } from '@prisjakt/ui-carousel';
import { AppContext } from '@prisjakt/ui-app-context';
import Lightbox from '../../../../components/lightbox';
import productMediaActions from '../../actions/media';

const ProductMediaLightbox = ({
  media,
  position,
  close,
  productMediaSetPosition,
}) => {
  const { t } = useContext(AppContext);
  const { videos, images, large: largeImages } = media;

  let thumbnails = images;
  if (videos) {
    thumbnails = thumbnails.concat(
      videos.map(video => (
        <VideoThumbnail key={video.source_id} src={video.thumbnail} />
      ))
    );
  }
  let items =
    largeImages && largeImages.map(src => <img key={src} src={src} alt="" />);

  if (videos) {
    items = items.concat(
      videos.map(video => (
        <Video key={video.source_id} src={video.embed_url}>
          <p>{t('product', 'video.brand-disclaimer')}</p>
        </Video>
      ))
    );
  }

  return (
    <Lightbox
      items={items}
      thumbnails={thumbnails}
      position={position}
      close={close}
      onChange={(index, type) =>
        productMediaSetPosition(index, { action: type })
      }
      isOpen
    />
  );
};

const { object, number, func } = PropTypes;
ProductMediaLightbox.propTypes = {
  media: object,
  position: number,
  productMediaSetPosition: func,
  close: func,
};

ProductMediaLightbox.defaultProps = {
  media: {
    videos: null,
  },
  position: 0,
  productMediaSetPosition: () => {},
  close: () => {},
};

export default connect(
  () => ({}),
  memo(productMediaActions)
)(ProductMediaLightbox);
